module.exports = __webpack_public_path__ + "moderation-complete.0108a371c6fabcc9a289b0dead036358.svg";